import { StyleSheet } from "@react-pdf/renderer";
const Home = () => {
 const styles = StyleSheet.create({
   page: {
    flexDirection: "row",
    backgroundColor: "#61dafb",
  },
    nobullets: {
    listStyleType: "none",
  },
 });
    return (
      <div style={styles.page}>
            <h1 align="center">Welcome to Internet Software Works (ISW)</h1>
            <br />
            <h3 align="center">Your Partner in Custom Full-Stack Software Development</h3>
            <br />
            <p>
                Internet Software Works (ISW) is a software development consultancy
                specializing in custom full-stack solutions tailored to your business needs.
                Whether you’re building a completely new product or modernizing an existing system,
                ISW can turn your vision into reality using modern technologies and industry-proven development practices.
            </p>
            <p>
                We also provide expert guidance on hosting and cloud options that help reduce
                infrastructure costs while improving performance and scalability. From mobile
                apps to multilingual web applications, ISW is equipped to deliver high-quality, reliable solutions.
            </p>
            <h3 align="center">Have an idea? Send it our way — we can build it.</h3>
            <br />

            <h3>Services</h3>
            <br />
            <ul style={styles.nobullets}>
                <li>Full-stack application development</li>
                <li>Non-Emergency Medical Transport (NEMT) consulting</li>
                <li>Product design, including epics and user stories</li>
                <li>Mobile Application development</li>
                <li>Hosting and cloud infrastructure consulting</li>
                <li>Database design, optimization, and performance tuning</li>
                <li>API development and integration</li>
                <li>Cloud architecture and deployment</li>
                <li>Ongoing maintenance and support</li>
            </ul>
            <br />
             <h3 align="left">Modernize Your Web Presence</h3><p>
                Let ISW help you update and modernize your website using
                the latest technology. We can build a responsive, mobile-ready Single Page Application (SPA)
                that provides an exceptional user experience across devices. By leveraging your existing
                backend functionality, we can reduce development time and costs while
                delivering a faster, cleaner, and more modern interface.
            </p>
        </div>
            );
};
            export default Home;